import React, {useEffect,useState} from 'react'
import '../assets/styles/styles.scss'
import { useTranslation } from 'react-i18next';
import forthcode04 from "../assets/forthcode04.svg"
import {APP_VERSION} from '../utils/configs';


export const Footer=({mode}) =>{
  const [menuState, setmenuState] = useState(true);
  useEffect(() => {
      setmenuState(mode);
  }, [mode])

  const footerState = `footer${menuState === 'collapsed' ? '_collapsed' :menuState==='opened'?"-login":" "}`;
  const { t } = useTranslation();

  return (
    <div className={footerState}>
    {
      (footerState !== 'footer_collapsed' && footerState !== 'footer-login') ? (<>
   <div className='width100 flexRow justifyContentSpaceBetween alignItemsCenter footer-text-in content-tabs'>
  <div className='flexCol'>
    {t('company.poweredBy')} 
    <div className='flexRow'>
      <img src={forthcode04} alt="organization-logo" />
    </div>
  </div>
  <div className='flexRow alignItemsCenter'>
    {APP_VERSION}
  </div>
</div>

      </>
      
      ) : footerState === 'footer-login' ? (
        <div className='flexCol justifyContentCenter alignItemsCenter footer-text-in'>
            {t('company.poweredBy')} 
            <div className='flexRow'>
            <img src={forthcode04} alt="organization-logo" className="footer-style"/>
              </div>
        </div>
      ) : (
        <div className="flexCol" style={{ fontSize: '10px', marginLeft: '10px' }}>
          {t('company.poweredBy')} &nbsp;
          <div className='flexRow'>
            {t('company.brandName')} <span className="registered-mark">®</span>
          </div>

        </div>
      )
    }
     {/* {
      (footerState !== 'footer_collapsed' && footerState !== 'footer-login') && (
        <img src={footerline} alt="footer line" className="footer-logo" />
      )
    } */}
 {/* {footerState !== 'footer-login' ? <div style={{ color: `${footerState === 'footer-login' ? "#fff" : ""}` }}>
     {APP_VERSION}
    </div>:null } */}


  </div>

  )
}
